angular.module('rjmNg.directives').directive 'userProfile', [
  'app'
  (app) ->
    restrict: 'E'
    templateUrl: 'settings/directive.userProfile.html'
    replace: true
    controllerAs: 'view'
    bindToController: true
    controller: [
      '$timeout'
      'Users'
      'colorThemeConstants'
      'colorThemeService'
      'notification'
      (
        $timeout
        Users
        colorThemeConstants
        colorThemeService
        notification
      ) ->

        view = @
        view.COLOR_THEMES = colorThemeConstants.THEME_NAMES
        view.currentColorThemeId = null
        view.isSaveColorThemeDisabled = true
        view.COLOR_THEMES_AVAILABLE = not app.hasFeatureFlag('UNIQUE_SERIES_COLORS')
        view.SHOW_PASSWORD_CHANGE = not app.isImsSession()

        SAVE_TIMEOUT_MS = 4500
        NOTIFICATION_TIMEOUT = 10
        NOTIFICATION_SCOPE = "personal-information"
        saveNameTimeoutPromise = null
        saveEmailTimeoutPromise = null

        _updateCurrentColorThemeId = () ->
          view.currentColorThemeId = view.user.properties.color_theme_id

        _checkIfCanSaveColorTheme = () ->
          view.isSaveColorThemeDisabled = view.currentColorThemeId is view.user.properties.color_theme_id

        view.setColorTheme = (colorThemeId) ->
          view.user.properties.color_theme_id = colorThemeId
          _checkIfCanSaveColorTheme()

        init = ->
          view.loading = true
          Users.get app.getUserId()
          .then (user) ->
            view.user = user
            view.currentEmailInput = view.user.email
            _updateCurrentColorThemeId()
            view.loading = false

          view.isSupportUser = app.isSupportUserSession()
          view.isOnlyADemoUser = app.isOnlyADemoUser()
          view.lockPersonalInfo = app.getLockPersonalInfo()

          view.tosLink = 'https://magento.com/legal/terms'

        view.saveName = ->
          view.nameNotification = false
          view.saveNameError = false
          view.savingUser = true

          Users.save(view.user)
          .then () ->
            view.savingUser = false
            view.nameNotification = true

            if saveNameTimeoutPromise
              $timeout.cancel saveNameTimeoutPromise

            saveNameTimeoutPromise = $timeout ->
              view.nameNotification = false
              saveNameTimeoutPromise = null
            , SAVE_TIMEOUT_MS
          .catch (failure) ->
            view.savingUser = false
            view.saveNameError = true
            view.saveNameErrorMessage = failure?.data?.message

        view.saveEmail = ->
          view.emailNotification = false
          view.savingEmail = true
          view.saveEmailError = false
          view.saveEmailErrorMessage = null
          view.user.email = view.currentEmailInput

          Users.save(view.user)
          .then () ->
            view.savingEmail = false
            view.emailNotification = true

            if saveEmailTimeoutPromise
              $timeout.cancel saveEmailTimeoutPromise

            saveEmailTimeoutPromise = $timeout ->
              view.emailNotification = false
              saveEmailTimeoutPromise = null
            , SAVE_TIMEOUT_MS
          .catch (failure) ->
            view.savingEmail = false
            view.saveEmailError = true
            view.saveEmailErrorMessage = failure?.data?.message

        view.togglePasswordOpen = ->
          if view.savingPassword
            return

          view.oldPassword = ''
          view.newPassword = ''
          view.confirmPassword = ''
          view.passwordOpen = not view.passwordOpen
          view.passwordNotification = false
          view.showOldPasswordErrors = false
          view.showNewPasswordErrors = false
          view.showConfirmPasswordErrors = false

        view.saveColorTheme = () ->
          colorThemeService.saveColorTheme(
            view.user.id
            view.user.properties.color_theme_id
          ).then () ->
            _updateCurrentColorThemeId()
            _checkIfCanSaveColorTheme()
            notification.clear(NOTIFICATION_SCOPE)
            notification.success(
              null
              "Color theme applied successfully."
              NOTIFICATION_SCOPE
              {}
              NOTIFICATION_TIMEOUT
            )
          .catch (failure) ->
            notification.clear(NOTIFICATION_SCOPE)
            notification.error(
              null
              "Failed to apply color theme. Please try again or contact support."
              NOTIFICATION_SCOPE
              {}
              NOTIFICATION_TIMEOUT
            )

        view.savePassword = ->
          view.passwordNotification = false
          view.passwordError = false
          view.savingPassword = true

          Users.updatePassword(
            view.user.id,
            view.oldPassword,
            view.newPassword,
          ).then () ->
            view.savingPassword = false
            view.togglePasswordOpen()
            view.passwordNotification = true
          .catch (result) ->
            view.savingPassword = false
            view.passwordError = if result.data?.error?.message?\
              then result.data.error.message\
              else 'Something went wrong. Please try again later.'

        @$onInit = ->
          init()

        view
    ]

]
